"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/jsx-fragments */
// @ts-nocheck
const bind_1 = __importDefault(require("classnames/bind"));
const react_1 = __importDefault(require("react"));
const shift_1 = require("@app/component/modals/shift-1.5/shift");
const const_1 = require("@app/const");
const util_1 = require("@app/util");
const use_modal_hoc_1 = require("@app/util/modal/use-modal-hoc");
const _ui_1 = require("@ui");
const event_1 = __importDefault(require("@ui/calendar/common/event"));
const connect_1 = __importDefault(require("./connect"));
const index_scss_1 = __importDefault(require("./index.scss"));
const cx = bind_1.default.bind(index_scss_1.default);
class ShiftTemplates extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            displayedPage: 0,
        };
    }
    render() {
        const { labelWidthRem, workspace, cols, setModal, isLoading, style } = this.props;
        const { displayedPage } = this.state;
        const templates = workspace.shiftTemplates?.length
            ? workspace.shiftTemplates
            : [];
        const sortedTemplates = templates.sort((a, b) => {
            return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
        });
        // paging for template list
        const maxTemplatesPerPage = cols.length;
        const displayedTemplates = sortedTemplates.slice(displayedPage * maxTemplatesPerPage, (displayedPage + 1) * maxTemplatesPerPage);
        // displayedTemplates = displayedTemplates.sort((a, b) => {
        //   return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
        // })
        return (react_1.default.createElement("div", { className: cx('ds-c-stmpl-row ds-c-row'), style: style },
            isLoading ? (react_1.default.createElement("div", { className: cx('ds-c-stmpl-row-loader-overlay') },
                react_1.default.createElement(_ui_1.Loader, { size: _ui_1.Loader.SIZES.SMALL }))) : null,
            react_1.default.createElement("div", { className: cx('ds-c-row-label'), style: {
                    width: labelWidthRem.toString() + 'rem',
                    minWidth: labelWidthRem.toString() + 'rem',
                    maxWidth: labelWidthRem.toString() + 'rem',
                } },
                react_1.default.createElement("span", null, (0, util_1.t)('CALENDAR_ROWS_TEMPLATES')),
                templates.length > maxTemplatesPerPage && (react_1.default.createElement("div", { className: 'ds-c-stmpl-paging' },
                    react_1.default.createElement("div", { className: 'ds-c-stmpl-paging-btn' +
                            ((displayedPage + 1) * maxTemplatesPerPage >= templates.length
                                ? ' is-disabled'
                                : ''), onClick: () => {
                            if ((displayedPage + 1) * maxTemplatesPerPage >= templates.length)
                                return false;
                            this.setState((s) => Object.assign({}, s, { displayedPage: displayedPage + 1 }));
                        } },
                        react_1.default.createElement("svg", { viewBox: '0 0 8 8', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
                            react_1.default.createElement("path", { d: 'M4.26563 1.03125C4.125 0.890625 3.89063 0.890625 3.75 1.03125L0.703126 4.0625C0.562501 4.21875 0.5625 4.45312 0.703125 4.59375L1.0625 4.95312C1.20313 5.09375 1.4375 5.09375 1.59375 4.95312L4 2.54687L6.42188 4.95312C6.57813 5.09375 6.8125 5.09375 6.95313 4.95312L7.3125 4.59375C7.45313 4.45312 7.45313 4.21875 7.3125 4.0625L4.26563 1.03125Z' }))),
                    react_1.default.createElement("div", { className: 'ds-c-stmpl-paging-btn' +
                            (displayedPage <= 0 ? ' is-disabled' : ''), onClick: () => {
                            if (displayedPage <= 0)
                                return false;
                            this.setState((s) => Object.assign({}, s, { displayedPage: displayedPage - 1 }));
                        } },
                        react_1.default.createElement("svg", { viewBox: '0 0 8 8', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
                            react_1.default.createElement("path", { d: 'M3.73438 4.96875C3.875 5.10938 4.10938 5.10938 4.25 4.96875L7.29688 1.9375C7.4375 1.78125 7.4375 1.54688 7.29688 1.40625L6.9375 1.04688C6.79688 0.90625 6.5625 0.90625 6.40625 1.04688L4 3.45312L1.57812 1.04688C1.42188 0.90625 1.1875 0.90625 1.04688 1.04688L0.6875 1.40625C0.546875 1.54688 0.546875 1.78125 0.6875 1.9375L3.73438 4.96875Z' })))))),
            displayedTemplates.length ? (displayedTemplates.map((tpl, idx) => {
                if (!tpl.shift)
                    return null;
                if (idx >= maxTemplatesPerPage)
                    return null; // only display limited number of templates
                return (react_1.default.createElement("div", { key: tpl.id, className: cx('ds-c-col'), style: {
                        width: 'calc((100% - ' +
                            labelWidthRem.toString() +
                            'rem) / ' +
                            (cols.length || 1).toString() +
                            ')',
                        minWidth: 'calc((100% - ' +
                            labelWidthRem.toString() +
                            'rem) / ' +
                            (cols.length || 1).toString() +
                            ')',
                        maxWidth: 'calc((100% - ' +
                            labelWidthRem.toString() +
                            'rem) / ' +
                            (cols.length || 1).toString() +
                            ')',
                    } },
                    react_1.default.createElement(event_1.default, { type: 'shiftTemplate', data: Object.assign({}, tpl.shift, {
                            id: tpl.id,
                            shiftTemplateName: tpl.name,
                        }), key: 'tpl_' + tpl.id, idx: idx })));
            })) : (react_1.default.createElement("div", { className: 'ds-c-stmpl-no-templates' },
                react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM, color: _ui_1.Text.COLORS.GRAY }, (0, util_1.t)('TPL_ROW_NO_TEMPLATES')))),
            displayedTemplates.length < maxTemplatesPerPage &&
                util_1.permissionsUtil.canWrite(const_1.PERMISSIONS.WORKSPACE.SHIFTTEMPLATES) ? (react_1.default.createElement("div", { className: cx('ds-c-col'), style: {
                    width: 'calc((100% - ' +
                        labelWidthRem.toString() +
                        'rem) / ' +
                        (cols.length || 1).toString() +
                        ')',
                    minWidth: 'calc((100% - ' +
                        labelWidthRem.toString() +
                        'rem) / ' +
                        (cols.length || 1).toString() +
                        ')',
                    maxWidth: 'calc((100% - ' +
                        labelWidthRem.toString() +
                        'rem) / ' +
                        (cols.length || 1).toString() +
                        ')',
                } },
                react_1.default.createElement("div", { className: cx('ds-c-col-hover-btns') },
                    react_1.default.createElement(_ui_1.Button, { onClick: (e) => {
                            // setModal('extra-shift-template')
                            this.props.openModal(shift_1.ShiftModal, {
                                initialData: {
                                    type: 'shiftTemplate',
                                },
                            });
                        }, ico: _ui_1.Icon.ICONS.plus })))) : null));
    }
}
exports.default = (0, connect_1.default)((0, use_modal_hoc_1.withUseModalHOC)(ShiftTemplates));
